import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Send, EmojiEmotions } from "@material-ui/icons";
import EmojiPicker from "./EmojiPicker";
import { useEmojiPicker } from "../contexts/EmojiPickerContext";
import firebase from "firebase/app";
import "firebase/firestore";
import { useAuth } from "../contexts/AuthContext";

const db = firebase.firestore();

const drawerWidth = 300;

const useStyle = makeStyles((theme) => ({
  bottomAppBar: {
    top: "auto",
    bottom: 0,
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    backgroundColor: theme.palette.common.white,
  },
  mobileBottomAppBar: {
    width: "100%",
    marginLeft: 0,
    bottom: 0,
    top: "auto",
    backgroundColor: theme.palette.common.white
  },
}));

function MessageBar({ roomID, mobileDevice }) {
  const [message, setMessage] = React.useState("");
  const classes = useStyle();
  const { currentUser } = useAuth();

  const addEmoji = (emoji) => {
    setMessage(message.concat(emoji.native));
  };

  const sendMessage = () => {
    setMessage("");
    db.collection("messages")
      .add({
        content: message,
        roomID: roomID,
        senderID: currentUser.uid,
        time: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => {
        doc
          .update({
            messageID: doc.id,
          })
          .then(() => {
            console.log("messsage sent successfully");
          });
      });
  };

  const { setEmojiPicker } = useEmojiPicker();

  return (
    <>
      <AppBar
        position="fixed"
        color="primary"
        className={clsx(classes.bottomAppBar, {
          [classes.mobileBottomAppBar]: mobileDevice,
        })}
      >
        <Toolbar>
          <TextField
            multiline
            fullWidth
            variant="standard"
            className={classes.textField}
            maxRows={3}
            autoComplete="off"
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            onPointerDown={() => setEmojiPicker(null)}
            value={message}
            placeholder="Type a message..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    onClick={(e) => {
                      setEmojiPicker(e.currentTarget);
                    }}
                  >
                    <EmojiEmotions />
                  </IconButton>
                </InputAdornment>
              ),

              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={sendMessage}
                    type="submit"
                    aria-label="send-message-button"
                    edge="end"
                  >
                    <Send />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            labelWidth={70}
          />
        </Toolbar>
      </AppBar>
      <EmojiPicker onSelect={(emoji) => addEmoji(emoji)} />
    </>
  );
}

export default MessageBar;
